import React from 'react';
import { Redirect } from 'react-router-dom';

import { useActiveLicense } from 'containers/Subscription/hooks';
import { subscriptionStatusTypes } from 'utils/subscription/statusTypes';

/**
 * Component that guards content based on license validation
 * Automatically redirects to subscription page if license is invalid
 *
 * Replicates the exact behavior of the original withRequiredLicense HOC
 *
 * @param {Object} props - Component properties
 * @param {React.ReactNode} props.children - Content to render if license is valid
 * @returns {React.ReactElement} Protected content or redirect
 */
export const LicenseGuard = ({ children }) => {
  const { data: license } = useActiveLicense();

  // Exact same logic as original withRequiredLicense HOC
  const isRedirectToSubscriptionPath =
    license?.status === subscriptionStatusTypes.UNAVAILABLE ||
    license?.status === subscriptionStatusTypes.PAYMENT_REQUIRED;

  if (isRedirectToSubscriptionPath) {
    return <Redirect to="/subscriptions" />;
  }

  return <>{children}</>;
};
